<h3 class="title-h3">
	{{'bookingPayment.title.paymentWithMulticaixa' | ibeadmin | async}}
</h3>
<!--
<p class="description">
	{{'bookingPayment.text.exchangeRateUsed' | ibeadmin | async}}: 1 USD = 344.2223 AOA
</p>
-->

<div class="container no-pad-bottom no-pad-h" *ngIf="hasMilesPayable">
	<app-notification [style]="'information'" [icon]="'icons.svg#general--information'"
	[title]="'bookingPayment.title.milesRedemption' | ibeadmin | async">
		<div message>
			<span>
				{{'bookingPayment.text.pleaseNoteMilesRedeem' | ibeadmin | async}}
			</span>
		</div>
	</app-notification>
</div>

<form [formGroup]="form">
	<div class="phone-container">
		<label class="label" for="multicaixa-phone-number">
			{{'bookingPayment.text.insertMobile' | ibeadmin | async}}
		</label>
		<div class="input-wrap">
			<span class="input-prefix">+244</span>
			<input formControlName="phoneNumber" 
				name="multicaixa-phone-number" 
				type="text" 
				inputmode="numeric"
				id="multicaixa-phone-number"
				attr.aria-label="{{'bookingPayment.aria.insertMobile' | ibeadmin | async}}" 
				class="input-text {{ hasErrorClassPhoneNumber }}"
				aria-required="true" 
				autocomplete="false"
				pattern="[0-9]*" size="4" maxlength="9" appNumberOnly>
			<span 
				aria-live="polite"
				[attr.aria-label]="INDRA_formErrors('phoneNumber')"
				class="input-error" 
				role="alert" 
				*ngIf="form.controls['phoneNumber'].invalid && form.touched">
				{{ INDRA_formErrors('phoneNumber') }}
			</span>
		</div>
	</div>

	<p class="bottom-gap">{{'bookingPayment.text.paymentAtAtm' | ibeadmin | async}}</p>

	<!--
	<app-notification [style]="'information'" [icon]="'icons.svg#general--timer'"
		[title]="'bookingPayment.text.validForPayment48hrs' | ibeadmin | async">
		<div message>
			<span>{{'bookingPayment.text.reservationValid' | ibeadmin | async}}</span><br>
			<span>{{'bookingPayment.text.lackOfPayment' | ibeadmin | async}}</span>
		</div>
	</app-notification>
	-->

	<app-notification [style]="'information'" [icon]="'icons.svg#general--timer'"
		[title]="('bookingPayment.text.reservationValidFor' | ibeadmin | async) + reservationValidityInHours + ' ' + ('bookingPayment.text.hours' | ibeadmin | async)">
		<div message>
			<span>
				{{'bookingPayment.text.makeThePayment' | ibeadmin | async}} {{ reservationValidityInHours }} {{'bookingPayment.text.reservationWillBeCancelled' | ibeadmin | async}}
			</span>
		</div>
	</app-notification>
	
	<div class="payment-option__conditions-wrapper" [class.has-error]="!(formIsValid$ | async)">
	<div class="payment-option__conditions">
		<app-checkbox-input formControlName="accepted_conditions" label="" [class.has-error]="!(formIsValid$ | async)"></app-checkbox-input>
		<span>
			{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
			<a class="link" href="javascript:;" 
				(click)="INDRA_handleBookingTicketConditions()" 
				attr.aria-label="{{'bookingPayment.aria.openFare' | ibeadmin | async}}'" 
				role="button">
				{{'bookingPayment.text.fareConditions' | ibeadmin | async}}
			</a> 
			{{'bookingPayment.text.andThe' | ibeadmin | async}} 
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.transportConditions')"
				attr.aria-label="{{'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async}}">
				{{'bookingPayment.text.tncCarriage' | ibeadmin | async}}
			</a> 
			<!--{{'bookingPayment.text.andThe' | ibeadmin | async}}
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
				{{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
			</a>-->
			<ng-container *ngIf="displayCovidTermsAndCondition">
				, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
					{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
				</a>
				{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
			</ng-container>
		</span>
	</div>
</div>

</form>


